import api from "../hooks/api";
import { API_URLS } from "../App";
import type { ManagementCompoundComponent } from "../model/ManagementCompoundComponent";

// ponytail: flat service — no IoC container needed for this scope

function normalizeComponent(
  c: ManagementCompoundComponent,
): ManagementCompoundComponent {
  return {
    ...c,
    quantity:
      typeof c.quantity === "string"
        ? parseInt(c.quantity, 10) || 1
        : c.quantity || 1,
    configured_compound_reseller_price: Number(
      c.configured_compound_reseller_price,
    ),
    configured_discount_rate: Number(c.configured_discount_rate),
    configured_discount_value: Number(c.configured_discount_value),
    configured_reseller_price: Number(c.configured_reseller_price),
    configured_cost_price: Number(c.configured_cost_price),
    erp_compound_reseller_price: Number(c.erp_compound_reseller_price),
    erp_discount_rate: Number(c.erp_discount_rate),
    erp_discount_value: Number(c.erp_discount_value),
    erp_reseller_price: Number(c.erp_reseller_price),
    erp_cost_price: Number(c.erp_cost_price),
    vat_rate: Number(c.vat_rate),
    configured_available_quantity: Number(c.configured_available_quantity),
    erp_available_quantity: Number(c.erp_available_quantity),
  };
}

export async function addComponent(
  compoundId: string,
  component: ManagementCompoundComponent,
) {
  const res = await api.post(
    API_URLS.COMPOUNDS + `/${encodeURIComponent(compoundId)}/components`,
    normalizeComponent(component),
  );
  return res.data;
}

export async function updateComponent(
  compoundId: string,
  componentId: string,
  component: ManagementCompoundComponent,
) {
  const res = await api.put(
    API_URLS.COMPOUNDS +
      `/${encodeURIComponent(compoundId)}/components/${encodeURIComponent(componentId)}`,
    normalizeComponent(component),
  );
  return res.data;
}

export async function deleteComponent(compoundId: string, componentId: string) {
  const res = await api.delete(
    API_URLS.COMPOUNDS +
      `/${encodeURIComponent(compoundId)}/components/${encodeURIComponent(componentId)}`,
  );
  return res.data;
}

export async function updateCompound(
  compoundId: string,
  body: Record<string, unknown>,
) {
  const res = await api.put(
    API_URLS.COMPOUNDS + `/${encodeURIComponent(compoundId)}`,
    body,
  );
  return res.data;
}
